export default __webpack_public_path__ + "static/media/simple4.e5489d51.webp";